import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { INGREDIENT_SPECIAL_CASE_FRAGMENT } from '../fragments'

const INGREDIENT_SPECIAL_CASES_QUERY = gql`
  query ingredientSpecialCases {
    ingredientSpecialCases {
      results {
        ...IngredientSpecialCaseFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${INGREDIENT_SPECIAL_CASE_FRAGMENT}
  ${EVENT_FRAGMENT}
`

export default INGREDIENT_SPECIAL_CASES_QUERY
